/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './external.defs.js'
export * as $defs from './external.defs.js'
